import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { SocialMediaSettings } from "@/components/AccountMenu/SocialMediaSettings";
import { Switch } from "@/components/ui/switch";
import { useWebsites } from "@/context/WebsitesContext";
import { useSettingsState } from "@/context/SettingsStateContext";

export default function SocialMediaCard() {
  const { currentWebsite, updateWebsite } = useWebsites();
  const { isSocialMediaEnabled, setIsSocialMediaEnabled } = useSettingsState();

  return (
    <Card id="social">
      <CardHeader>
        <CardTitle>Social media</CardTitle>
        <CardDescription>
          Configure social media platforms for content distribution
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label>Enable Social Media Integration</Label>
              <p className="text-sm text-muted-foreground">
                Automatically share your content across social media platforms
              </p>
            </div>
            <Switch
              checked={isSocialMediaEnabled}
              onCheckedChange={async (checked) => {
                if (!currentWebsite) {
                  toast.error("Please select a website first");
                  return;
                }
                try {
                  await updateWebsite(currentWebsite.id, {
                    enable_some: checked,
                  });
                  setIsSocialMediaEnabled(checked);
                  toast.success(
                    checked
                      ? "Social media integration enabled"
                      : "Social media integration disabled"
                  );
                } catch (error) {
                  console.error("Failed to update social media setting:", error);
                  toast.error("Failed to update social media setting");
                }
              }}
            />
          </div>

          {isSocialMediaEnabled && (
            <div className="mt-6">
              <SocialMediaSettings />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
